import {db} from '../../../utils/firebase';

export const saveAutoTracksToDb = (autoRecords, fetchingState, setFetchingState) => {
    setFetchingState({...fetchingState, streams: true});

    return db
        .doc('autoStreamsTracks/tracks')
        .set({autoRecords})
        .then(() => ({
            error: false,
            message: 'Треки автостримов успешно сохранены'
        }))
        .catch(error => ({
            error: true,
            message: 'Ошибка при сохранении треков автостримов',
            firebaseError: error
        }))
        .finally(() => setFetchingState({...fetchingState, streams: false}))
}

export const getAutoTracksFromDb = (fetchingState, setFetchingState) => {
    setFetchingState({...fetchingState, streams: true});

    return db
        .doc(`autoStreamsTracks/tracks`)
        .get()
        .then((doc) => {
            let autoRecords = [];
            if (doc.exists) {
                autoRecords = doc.data().autoRecords;
            }

            return {error: false, autoRecords};
        })
        .catch((error) => ({
            error: true,
            message: 'Ошибка при получении треков автостримов',
            firebaseError: error
        }))
        .finally(() => setFetchingState({...fetchingState, streams: false}))
}
